import React from "react";
import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {BreadcrumbItem, Breadcrumb} from 'react-bootstrap';


const NewspaperMagazine = () =>{
  
  return (
    <div className="NewspaperMagazine">
      <section className="inner-banner banner-align">
      <img className="img-fluid" src="./assets/img/innerbanner/newspapermagazines.jpg" alt=""/>
    </section>
    <section  className="research-box-area">
         <Container>
         <Breadcrumb>
                <BreadcrumbItem>
                  <Link as={Link} to="/">
                         Home
                  </Link>
                  
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link as={Link} to="/FindResources">
                  Find Resources
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Newspapers and Magazines</BreadcrumbItem>
              </Breadcrumb>
            <div className='information-content'>
              <h2>Newspapers and Magazines</h2>
              {/* <p>THe HU LICS has access to the following online research databases:</p> */}
            </div>
            <Row>
                <Col lg={4} className="border-end">
                  <div className="research-box">
                       <h5>General Magazines</h5>
                       
                       <ul className="dotUl">
                        <li>The Economist</li>
                        <li>National Geographic</li>
                        <li>MIT Technology Review</li>
                        <li>HBR</li>
                        <li>Scientific American</li>
                       </ul>
                       <div className="  magz-img">
                        <img className="img-fluid" src="./assets/img/newspaper/general-magazine.JPG" alt="" />
                       </div>
                  </div>
                </Col>
                {/* <Col lg={4} className="border-end">
                  <div className="research-box">
                      <h5>Scholarly Magazines</h5>
                      <ul className="dotUl">
                        <li>IEEE Spectrum</li>
                        <li>IEEE Transactions of Human-Machine Systems</li>
                        <li>IEEE Computational Intelligence Magazine</li>
                        <li>IEEE Security & Privacy Magazine</li>
                        <li>Communications of the ACM</li>
                       </ul>
                       
                      <div className="magz-img">
                      <img className="img-fluid" src="./assets/img/newspaper/Scholarly-Magazines.png" alt="" />
                      </div>
                  </div>
                </Col> */}
                <Col lg={4}>
                  <div className="research-box">
                      <h5>Newspapers</h5>
                      
                      <ul className="dotUl">
                        <li>The Chronicle of Higher Education</li>
                        <li>Express</li>
                        <li>Tribune</li>
                        <li>Dawn</li>
                        <li>Jang</li>
                        <li>Kawish</li>
                       </ul>
                       <div className="  magz-img">
                      <img className="img-fluid" src="./assets/img/newspaper/newspapers.JPG" alt="" />
                      </div>
                  </div>
                </Col>
               
            </Row>
         </Container>
    </section>
   
     
    </div>
  );
}
export default NewspaperMagazine;